// Importar modulos del router de Angular
import {ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule, CanActivate, ExtraOptions} from '@angular/router';

// Importar Componentes
import {HomeComponent} from './components/home/home.component';

// Array de Rutas
const appRoutes: Routes = [
  {path: '', component: HomeComponent},
  // Ruta 404
  {path: '**', component: HomeComponent},
];

// Exportar el modulo del router
export const appRoutingProviders: any[] = [];

/*Opciones para hacer Anchor en Angular*/
const  routerOptions: ExtraOptions = {
  useHash: false,
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'enabled',
}
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);

